<template>
  <div class="box-login">
    <div>
       <div class="title-system"><img src="static/img/logo-pb.png"/></div>
    </div>

    <div class="box-body">
      <notifications group="alert">{{ error }}</notifications>
        <div class="box-form-login">
          <form class="login" @submit.prevent="login">
            <div class="card" data-background="color" data-color="blue">
              <div class="card-header">
                <h3 class="card-title">Login</h3>
              </div>
              <div class="card-content">
                <div class="form-group">
                  <label>{{ $t("49") }}</label>
                  <input required type="text" placeholder="User" v-model="username" class="form-control input-no-border">
                </div>
                <div class="form-group">
                  <label>{{ $t("58") }}</label>
                  <input required type="password" placeholder="Password" v-model="password" class="form-control input-no-border">
                </div>
                <!--<p-checkbox>Me lembre da próxima vez</p-checkbox>-->
              </div>
              <div class="card-fim text-center">
                <button type="submit" class="btn btn-fill btn-wd ">OK</button>
                <!--<div class="forgot">
                  <router-link to="/register">
                    Esqueci minha senha!
                  </router-link>
                </div>-->
              </div>
            </div>
          </form>
        </div>
    </div>
    <div class="footer">
      Copyright © {{ year }} <a href="http://www.semeq.com" target="_blank">SEMEQ</a><br>
      All rights reserved
    </div>


  </div>

</template>
<script>
import Vue from 'vue'
import {AUTH_REQUEST} from '../../../../store/actions/auth'
import axios from 'axios'


export default {
  name: 'login',
  data () {
    return {
      username: null,
      password: null,
      error: null,
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },
      year: new Date().getFullYear(),
    }
  },
  methods: {
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    login: function () {
      const { username, password } = this
      this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
        //this.$router.go('/')
        //função para gerar hash que ajuda a entrar no sistema online já logado.
        this.siteOnline()
      }, (res) => {
        this.$notify({
          component: {
            template: `<span><b>`+ this.$t("59") +`</b></span>`
          },
          type: 'danger',
          group: 'alert',
          horizontalAlign: 'center',
          verticalAlign: 'top'
        })
      })
    },
    siteOnline () {
      var self = this
      const API = process.env.ROOT_API   
      const ENDPOINT = 'v1/mysemeq-ambev/login-mysemeq-abi'

      axios({method: 'GET', url: API + ENDPOINT, params: {'user':self.username, 'pass':self.password} , headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        var res = resp.data
        //console.log('HASH: ', res)

        localStorage.setItem('hash', res)
        let hash = localStorage.getItem('hash')
        self.$router.go('/')
      })
      .catch(err => {
        // from mixin 
        self.ApiErrorHandler(self, error.response.data.status_code);
      })
    },
  },
  beforeDestroy () {
    this.closeMenu()
  },
  mounted () {
    console.log(process.env.ROOT_API)
  }
}
</script>

<style>
body{
  top:0px;
  width: 100%;
  margin: 0px auto;
  background-image: url('/static/img/background/fundo.jpg');
  background-color: #253648; 
  height: auto;
}
.box-login{
  top:0px;
  width: 100%;
  margin: 0px auto;
  height: auto;
}
.box-form-login{
  width: 315px;
  margin: 0px auto;
}
.login-page > .content, .lock-page > .content {
  padding-top: 30vh!important;
}
.vue-notifyjs .alert[data-notify="container"]{
  top:80px!important;
}
.title-system{
  text-align: center;
  height: 220px;  
}
.title-system img{
  width: 170px;
  height: auto;
  padding-top: 55px;
}
.box-body{
  width: 100%;
  height: 340px;
}
.footer{
  width: 100%;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.card-fim{
  padding: 0 15px 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue